module.exports = __webpack_public_path__ + "img/about.b2917fac.jpg";